export default (function (_ref) {
  var request = _ref.request;
  return {
    sourceUniqueBatchAdd: function sourceUniqueBatchAdd(data) {
      return request({
        url: '/source/uniqueBatch/add',
        method: 'post',
        data: data
      });
    },
    sourceUniqueBatchCancel: function sourceUniqueBatchCancel(id) {
      return request({
        url: "/source/uniqueBatch/".concat(id, "/cancel"),
        method: 'put'
      });
    },
    sourceUniqueBatchDel: function sourceUniqueBatchDel(id) {
      return request({
        url: "/source/uniqueBatch/".concat(id, "/del"),
        method: 'delete'
      });
    },
    sourceUniqueBatchQuery: function sourceUniqueBatchQuery(data) {
      return request({
        url: '/source/uniqueBatch/query',
        method: 'get',
        params: data
      });
    },
    sourceUniqueBatchDetail: function sourceUniqueBatchDetail(id) {
      return request({
        url: "/source/uniqueBatch/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});